import { getRuntime } from "@next-core/brick-kit";

getRuntime().registerLazyBricks(
"next-builder.builder-container",
() =>
  import(
    /* webpackChunkName: "lazy-bricks/builder-container.2a2a" */
    "../builder-container"
  )
);

getRuntime().registerLazyBricks(
"next-builder.event-config-form",
() =>
  import(
    /* webpackChunkName: "lazy-bricks/event-config-form.2a2a" */
    "../event-config-form"
  )
);

getRuntime().registerLazyBricks(
"next-builder.search-tree",
() =>
  import(
    /* webpackChunkName: "lazy-bricks/search-tree.2a2a" */
    "../search-tree"
  )
);

getRuntime().registerLazyBricks(
"next-builder.storyboard-lint-result",
() =>
  import(
    /* webpackChunkName: "lazy-bricks/storyboard-lint-result.2a2a" */
    "../storyboard-lint-result"
  )
);

getRuntime().registerLazyBricks(
"next-builder.api-request-form-item",
() =>
  import(
    /* webpackChunkName: "lazy-bricks/api-request-form-item.2a2a" */
    "../api-request-form-item"
  )
);

getRuntime().registerLazyBricks(
"next-builder.api-proxy-request",
() =>
  import(
    /* webpackChunkName: "lazy-bricks/api-proxy-request.2a2a" */
    "../api-proxy-request"
  )
);

getRuntime().registerLazyBricks(
  [
    "next-builder.workflow-create-data-item",
    "next-builder.workflow-edit-data-item",
    "next-builder.workflow-condition-item"
  ],
  () =>
    import(
      /* webpackChunkName: "lazy-bricks/~workflow.2a2a" */
      "./workflow"
    )
);

getRuntime().registerLazyBricks(
  [
    "next-builder.function-debugger-sidebar",
    "next-builder.function-debugger-toolbar",
    "next-builder.function-debugger-toolbar-v2",
    "next-builder.function-debugger-store",
    "next-builder.function-debugger-statusbar"
  ],
  () =>
    import(
      /* webpackChunkName: "lazy-bricks/~function-debugger.2a2a" */
      "./function-debugger"
    )
);

getRuntime().registerLazyBricks(
  [
    "next-builder.preview-container",
    "next-builder.workbench-action",
    "next-builder.workbench-action-list",
    "next-builder.workbench-brick-tree",
    "next-builder.workbench-data-tree",
    "next-builder.workbench-context-menu",
    "next-builder.workbench-brick-context-menu",
    "next-builder.workbench-mini-action-bar",
    "next-builder.workbench-pane",
    "next-builder.workbench-sidebar",
    "next-builder.workbench-store",
    "next-builder.workbench-tabs",
    "next-builder.workbench-tree",
    "next-builder.workbench-quick-entry",
    "next-builder.workbench-component-select",
    "next-builder.workbench-cache-action"
  ],
  () =>
    import(
      /* webpackChunkName: "lazy-bricks/~workbench.2a2a" */
      "./workbench"
    )
);